export default class InvoiceBilletItem {
  constructor (data = {}) {
    this.digitableLine = data.digitableLine || '';
    this.dueDate = data.dueDate ? new Date(data.dueDate) : null;
    this.discount = data.discount ? Number(data.discount) : 0;
    this.increase = data.increase ? Number(data.increase) : 0;
    this.value = data.value ? Number(data.value) : 0;
  }
}
